import { Link as AriaLink, RouterProvider } from 'react-aria-components';

import type { ReactNode } from 'react';

/**
 * Link is a text link that routes through the app's router when the app wraps
 * itself in LinkRouterProvider, and through the browser otherwise. Use it for
 * links inside design-system components; page code may keep using the
 * router's own Link.
 */
export function Link({ href, children }: { href: string; children: ReactNode }) {
  return (
    <AriaLink href={href} className="rs-link">
      {children}
    </AriaLink>
  );
}

/** LinkRouterProvider hands design-system links to the app's router, so a
 * breadcrumb navigates without a full page load. */
export const LinkRouterProvider = RouterProvider;
